import React from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import { useToasts } from "react-toast-notifications";
import api from "../../service/api";
import { AlertInfo } from "../AlertInfo";
import { Box, BoxGroup, BoxHeading } from "../Box";
import { ButtonSubmit } from "../Form/ButtonSubmit";
import Loading from "../Loading";
import Modal from "../ModalLib";

interface OrderConfirmedProps {
  orderId: string;
  onFinally?: () => void;
}

export function OrderConfirmed({ orderId, onFinally }: OrderConfirmedProps) {
  const { addToast } = useToasts();

  const [rejectOrder, setRejectOrder] = React.useState(false);
  const [confirmOrder, setConfirmOrder] = React.useState(false);
  const [acceptedPolicies, setAcceptedPolicies] = React.useState(false);
  const [isLoadingConfirm, setIsLoadingConfirm] = React.useState(false);

  async function handleConfirmOrder() {
    setIsLoadingConfirm(true);
    try {
      await api.patch(`/orders-confirmes/${orderId}`, { confirmed: true });
      setConfirmOrder(false);

      addToast("Pedido confirmado com sucesso!", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      addToast(
        "Desculpe, ocorreu um erro interno. Tente novamente mais tarde.",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    } finally {
      setIsLoadingConfirm(false);
      if (onFinally) onFinally();
    }
  }

  return (
    <>
      <Box style={{ marginBottom: "2rem" }}>
        <BoxHeading style={{ marginBottom: 0 }}>
          Confirmação do pedido
        </BoxHeading>

        <BoxHeading
          style={{
            marginTop: "1rem",
            marginBottom: 0,
            fontWeight: "lighter",
          }}
        ></BoxHeading>

        <BoxGroup>
          {/* <ButtonSubmit
                onClick={() => {
                  setRejectOrder(true);
                }}
              >
                Rejeito
              </ButtonSubmit> */}
          <ButtonSubmit
            style={{ background: "#2cb438" }}
            onClick={() => {
              setConfirmOrder(true);
            }}
          >
            Confirmo
          </ButtonSubmit>
        </BoxGroup>
      </Box>
      <AlertInfo
        title="Tem certeza que deseja rejeitar o pedido?"
        handle={() => {}}
        icon={RiCloseCircleFill}
        isViewModal={rejectOrder}
        setIsViewModal={setRejectOrder}
      />

      <Modal
        modalVisible={confirmOrder}
        setModalVisible={setConfirmOrder}
        title="Confirmação de Pedido"
        height={"98%"}
        maxWidth={"800px"}
      >
        <div style={{ padding: "1rem", flex: 1 }}>
          <h3>TERMO DE ACEITE DE INTENÇÃO DE COMPRA</h3>

          {/* Container com rolagem */}
          <div
            style={{
              maxHeight: "60vh",
              overflowY: "auto",
              paddingRight: "0.5rem",
              marginBottom: "1rem",
              border: "1px solid #ddd",
              borderRadius: "6px",

              background: "#fafafa",
            }}
          >
            <Agree />
          </div>

          <label
            style={{ display: "flex", alignItems: "center", marginTop: "1rem" }}
          >
            <input
              type="checkbox"
              checked={acceptedPolicies}
              onChange={(e) => setAcceptedPolicies(e.target.checked)}
              style={{ marginRight: "0.5rem" }}
            />
            Li e aceito as políticas de aceitação do pedido.
          </label>

          <div style={{ display: "flex", gap: "1rem", marginTop: "auto" }}>
            <ButtonSubmit
              style={{ background: "#2cb438" }}
              onClick={handleConfirmOrder}
              disabled={!acceptedPolicies || isLoadingConfirm}
            >
              {isLoadingConfirm ? <Loading /> : "Aceitar e Confirmar"}
            </ButtonSubmit>
          </div>
        </div>
      </Modal>
    </>
  );
}

export function Agree() {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.6,
        margin: 20,
        color: "#333",
      }}
    >
      <p style={{ margin: "10px 0" }}>
        Ao clicar em <strong>"Li e Aceito"</strong>, o CLIENTE declara ter lido,
        compreendido e estar de acordo com os termos e condições abaixo, os
        quais regulam a intenção de compra realizada no portal da ALPAR.
      </p>
      <p style={{ margin: "10px 0" }}>
        O CLIENTE reconhece que, embora esta intenção de compra não configure um
        pedido em caráter definitivo, o seu aceite gera obrigações comerciais e
        operacionais, sujeitas às penalidades aqui previstas em caso de
        cancelamento, descumprimento ou inércia.
      </p>

      <ol style={{ marginLeft: 20 }}>
        <li style={{ marginBottom: 15 }}>
          <strong>Prazo de Entrega e Condições da Coleção</strong>
          <br />
          O CLIENTE reconhece que esta intenção de compra refere-se a uma
          coleção específica, e que o mês de entrega informado é apenas uma
          previsão, sujeita a alterações conforme o recebimento dos produtos
          pelas marcas representadas.
          <br />
          Exemplo: uma entrega prevista para janeiro da coleção Spring
          (jan/fev/mar) poderá ocorrer em qualquer mês dentro desse período.
          <br />
          Cancelamentos somente serão aceitos caso o envio ultrapasse o prazo da
          coleção. Caso o CLIENTE não solicite o cancelamento e a mercadoria
          seja enviada, o recebimento é obrigatório. A recusa no recebimento
          implicará na cobrança do frete e da multa de 20% sobre o valor da Nota
          fiscal.
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Confirmação de Dados Cadastrais</strong>
          <br />O CLIENTE declara que os dados fornecidos em seu cadastro estão
          atualizados e corretos, responsabilizando-se por mantê-los assim. A
          ALPAR não responderá por falhas de comunicação decorrentes de
          informações incorretas ou desatualizadas.
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Cancelamento da intenção de Compra</strong>
          <br />
          O CLIENTE poderá solicitar o cancelamento no prazo de até 7 (sete)
          dias corridos após o aceite da intenção de compra.
          <br />
          Após esse prazo, o cancelamento estará sujeito à cobrança de multa de
          20% (vinte por cento) sobre o valor total da intenção de compra, a
          título de perdas e danos, em razão de prejuízos gerados no
          planejamento de compras, produção, estoque e logística da ALPAR.
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Condições Comerciais e Penalidades por Recorrência</strong>
          <br />
          O CLIENTE declara ciência de que sua condição comercial com a ALPAR
          está condicionada ao cumprimento das regras de cancelamento e
          devolução.
          <br />
          Em caso de reincidência, a ALPAR poderá, a seu critério:
          <ul style={{ marginLeft: 20, listStyleType: "disc" }}>
            <li>Bloquear o CLIENTE por 12 (doze) meses;</li>
            <li>
              Em nova reincidência, aplicar bloqueio por prazo indeterminado;
            </li>
            <li>
              Alterar, sem aviso prévio, as condições comerciais anteriormente
              ofertadas.
            </li>
          </ul>
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Validade da Intenção de Compra</strong>
          <br />A intenção de compra terá validade de 3 dias corridos a partir
          do envio. Caso não haja manifestação expressa do CLIENTE nesse prazo,
          a intenção será cancelada automaticamente, sem garantia de
          disponibilidade de produtos ou das condições comerciais inicialmente
          apresentadas.
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Responsabilidade sobre Pagamentos</strong>
          <br />O aceite desta intenção de compra autoriza a emissão do pedido
          formal, conforme condições previamente acordadas, e poderá gerar
          obrigações de pagamento a partir de sua formalização.
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Alterações pela Marca</strong>
          <br />O CLIENTE está ciente de que poderão ocorrer alterações por
          parte das marcas representadas (mix de produtos, grade, cores ou
          outras características), sem que isso configure inadimplemento
          contratual por parte da ALPAR. Alterações relevantes serão comunicadas
          sempre que possível.
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Meios de Prova e Registro Eletrônico</strong>
          <br />
          Todos os registros de aceite realizados no portal da ALPAR — incluindo
          cliques, seleções e confirmações — terão validade legal plena e
          poderão ser utilizados como prova nos termos da legislação vigente.
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Uso do Login e Senha</strong>
          <br />
          O CLIENTE reconhece que o acesso ao portal se dá por meio de login e
          senha de uso pessoal, exclusivo e intransferível, sendo de sua inteira
          responsabilidade a guarda e uso dessas credenciais.
          <br />O aceite realizado por meio do login cadastrado será considerado
          válido para todos os fins legais, independentemente de quem tenha
          operado o sistema.
        </li>

        <li style={{ marginBottom: 15 }}>
          <strong>Declaração Final de Ciência e Responsabilidade</strong>
          <br />O CLIENTE declara estar ciente de que a presente intenção de
          compra não configura contrato definitivo de compra e venda, mas que o
          seu aceite implica em obrigações comerciais e operacionais reguladas
          por este termo, sujeitas a penalidades e reflexos nas relações futuras
          com a ALPAR.
        </li>
      </ol>

      <h2
        style={{
          marginTop: 40,
          fontSize: 18,
          color: "#444",
          textAlign: "center",
        }}
      >
        IMPORTANTE – POLÍTICA DE CONFERÊNCIA, DEVOLUÇÃO E RESSARCIMENTO
      </h2>

      <div
        style={{
          marginTop: 20,
          padding: 15,
          background: "#f9f9f9",
          border: "1px solid #ccc",
        }}
      >
        <p style={{ margin: "10px 0" }}>
          <strong>
            TODAS AS MERCADORIAS EMBARCADAS PELA ALPAR DO BRASIL SÃO PREVIAMENTE
            CONFERIDAS, ADESIVADAS E LACRADAS.
          </strong>
        </p>
        <p style={{ margin: "10px 0" }}>
          <strong>
            É OBRIGATÓRIA A CONFERÊNCIA DAS MERCADORIAS NO ATO DO RECEBIMENTO.
          </strong>
        </p>

        <p style={{ margin: "10px 0" }}>
          Em caso de divergência, avaria, falta de lacre, ausência de item ou de
          volume, o destinatário deve, obrigatoriamente:
        </p>
        <ul style={{ marginLeft: 20, listStyleType: "disc" }}>
          <li>
            Registrar a irregularidade no Conhecimento de Transporte ou na Nota
            Fiscal, de forma clara e legível;
          </li>
          <li>Carimbar, datar e assinar o documento no ato da entrega;</li>
        </ul>

        <p style={{ margin: "10px 0" }}>
          Nos casos de falta parcial de itens ou volumes, orientamos que:
        </p>
        <ul style={{ marginLeft: 20, listStyleType: "disc" }}>
          <li>
            Seja feita a ressalva detalhada no Conhecimento de Transporte
            indicando os produtos ou volumes faltantes;
          </li>
          <li>
            Os demais itens em perfeitas condições sejam recebidos normalmente.
          </li>
        </ul>

        <p style={{ margin: "10px 0" }}>
          Além disso, todas as solicitações de devolução, troca ou ressarcimento
          devem ser registradas exclusivamente por meio do nosso portal.
        </p>

        <p style={{ margin: "10px 0", color: "#c00", fontWeight: "bold" }}>
          ⚠ A ausência de conferência no momento da entrega e a falta de
          ressalva documental impedem o processamento de qualquer solicitação
          posterior de troca, devolução, ressarcimento ou indenização.
        </p>

        <p style={{ margin: "10px 0" }}>
          Solicitações que não atendam às condições acima serão indeferidas.
        </p>
      </div>
    </div>
  );
}
